import _ from 'underscore';
import { ProjectionGridBaseColumn } from '@bingads-webui/projection-grid-base-column';
import { RECOMMENDATION_TYPES } from '@bingads-webui-campaign/recommendation-core';
import template from './action-external-column.pug';

export class ActionExternalColumn extends ProjectionGridBaseColumn {
  constructor({ i18n, newI18n }) {
    super({
      name: 'Action',
      property: 'Recommendation/ActionExternal',
      title: i18n.getString('ColumnName_Action') || 'Action',
      bodyClasses: ['inline-action-view-column'],
      colClasses: ['col-external'],
    });
    this.i18n = i18n;
    this.newI18n = newI18n;
  }

  template({ value: { OpportunityType } }) {
    const { i18n, newI18n } = this;

    const actionName = {
      [RECOMMENDATION_TYPES.GOOGLE_IMPORT]: i18n.getString('Button_External_GoogleImport'),
      [RECOMMENDATION_TYPES.GOOGLE_IMPORT_SCHEDULED]: i18n.getString('Button_External_GoogleImport'),
      [RECOMMENDATION_TYPES.FIX_CONVERSION_TRACKING_OPPORTUNITY]: i18n.getString('Fix_Conversion_Tracking_Action'),
      [RECOMMENDATION_TYPES.FACEBOOK_IMPORT]: i18n.getString('Button_External_GoogleImport'),
      [RECOMMENDATION_TYPES.REPAIR_ADS]: newI18n.getString(_TL_('Create ad')),
    };
    return template({ action: actionName[OpportunityType] });
  }

  get property() {
    return {
      get: item => _.first(item.Opportunities),
    };
  }
}
